module.exports = __webpack_public_path__ + "media/images/cluster-3-digit-de9a9c8e5b1f5a02bdd44c1ff7710e7a.png";